<template>
  <div class="body-div">
    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in campTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedCampTab = tab.alias"
          :class="{ active: selectedCampTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>

    <!--    <div class="top-div">
      <loader :size="'11px'" v-if="reqReportsBusy"></loader>
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>-->
    <div class="stat-buttons">
      <button class="stat-button" v-on:click="getPerformanceByDate()">
        get latest statistics
      </button>
      <button class="stat-button" v-on:click="execCampSync()">
        get new statistics
      </button>
      <button class="stat-button" v-on:click="executeBrokersReports()">
        Trigger countries reports
      </button>
      <button class="stat-button" v-on:click="executeCountriesReports()">
        Trigger brokers reports
      </button>
    </div>
    <div class="bottom-div" v-if="selectedCampTab === 'PROFIT'">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <button v-on:click="getPerformanceByDate()">get latest statistics</button>
      <div class="table">
        <table
          :key="time"
          v-for="time in getPerformanceCampaignTimeFrames(
            profits[1].campPerformance
          )"
        >
          <thead>
            <tr class="text-center">
              LAST
              {{
                time
              }}
              DAYS
            </tr>
          </thead>

          <!-- Campaigns-->
          <tbody>
            <table
              v-for="camp in profits[1].campPerformance[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{ camp.id }} <br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>
                  [ {{ camp.total }} | ({{
                    getStatisticRatios(camp, camp).deposit_lead_ratio
                  }}) | {{ camp.deposits_amount }} | ({{
                    getStatisticRatios(camp, camp).deposit_uniques_ratio
                  }}) | {{ camp.uniques }} ]
                </td>
              </tr>
              <tr>
                <hr />
                profitable keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Users-->
          <tbody>
            <table
              v-for="camp in profits[1].userPerformance[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === camp.id).full_name
                  }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>
                  [ {{ camp.total }} | ({{
                    getStatisticRatios(camp, camp).deposit_lead_ratio
                  }}) | {{ camp.deposits_amount }} | ({{
                    getStatisticRatios(camp, camp).deposit_uniques_ratio
                  }}) | {{ camp.uniques }} ]
                </td>
              </tr>
              <tr>
                <hr />
                profitable keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Keywords-->
          <tbody>
            <table
              v-for="camp in profits[1].keyPerformance[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{ camp.id }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>
                  [ {{ camp.total }} | ({{
                    getStatisticRatios(camp, camp).deposit_lead_ratio
                  }}) | {{ camp.deposits_amount }} | ({{
                    getStatisticRatios(camp, camp).deposit_uniques_ratio
                  }}) | {{ camp.uniques }} ]
                </td>
              </tr>
              <tr>
                <hr />
                profitable campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Countries-->
          <tbody>
            <table
              v-for="camp in profits[1].countryPerformance[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === camp.id
                    ).name
                  }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>
                  [ {{ camp.total }} | ({{
                    getStatisticRatios(camp, camp).deposit_lead_ratio
                  }}) | {{ camp.deposits_amount }} | ({{
                    getStatisticRatios(camp, camp).deposit_uniques_ratio
                  }}) | {{ camp.uniques }} ]
                </td>
              </tr>
              <tr>
                <hr />
                profitable campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>
      <div
        class="loader-div"
        v-if="
          campPerformanceBusy['7'] ||
            campPerformanceBusy['30'] ||
            campPerformanceBusy['90'] ||
            campPerformanceBusy['180']
        "
      >
        <loader :size="'8px'"></loader>
      </div>
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
    <div class="bottom-div" v-if="selectedCampTab === 'UNPROFIT'">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="table">
        <table
          :key="time"
          v-for="time in getPerformanceCampaignTimeFrames(
            profits[0].campPerformance
          )"
        >
          <thead>
            <tr class="text-center">
              LAST
              {{
                time
              }}
              DAYS
            </tr>
          </thead>

          <!-- Campaigns-->
          <tbody>
            <table
              v-for="camp in profits[0].campPerformance[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{ camp.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>
                  [ {{ camp.total }} | ({{
                    getStatisticRatios(camp, camp).deposit_lead_ratio
                  }}) | {{ camp.deposits_amount }} | ({{
                    getStatisticRatios(camp, camp).deposit_uniques_ratio
                  }}) | {{ camp.uniques }} ]
                </td>
              </tr>
              <tr>
                <hr />
                loosing keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Users-->
          <tbody>
            <table
              v-for="camp in profits[0].userPerformance[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === camp.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>
                  [ {{ camp.total }} | ({{
                    getStatisticRatios(camp, camp).deposit_lead_ratio
                  }}) | {{ camp.deposits_amount }} | ({{
                    getStatisticRatios(camp, camp).deposit_uniques_ratio
                  }}) | {{ camp.uniques }} ]
                </td>
              </tr>
              <tr>
                <hr />
                loosing keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Keywords-->
          <tbody>
            <table
              v-for="camp in profits[0].keyPerformance[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{ camp.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>
                  [ {{ camp.total }} | ({{
                    getStatisticRatios(camp, camp).deposit_lead_ratio
                  }}) | {{ camp.deposits_amount }} | ({{
                    getStatisticRatios(camp, camp).deposit_uniques_ratio
                  }}) | {{ camp.uniques }} ]
                </td>
              </tr>
              <tr>
                <hr />
                loosing campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Countries-->
          <tbody>
            <table
              v-for="camp in profits[0].countryPerformance[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === camp.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>
                  [ {{ camp.total }} | ({{
                    getStatisticRatios(camp, camp).deposit_lead_ratio
                  }}) | {{ camp.deposits_amount }} | ({{
                    getStatisticRatios(camp, camp).deposit_uniques_ratio
                  }}) | {{ camp.uniques }} ]
                </td>
              </tr>
              <tr>
                <hr />
                loosing campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td>
                  [ {{ getStatisticRatios(camp, stat).profit_ratio }} |
                  {{
                    stat.profit
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}₪ ]
                </td>
                <td>
                  [ {{ stat.total }} | ({{
                    getStatisticRatios(camp, stat).deposit_lead_ratio
                  }}) | {{ stat.deposits_amount }} | ({{
                    getStatisticRatios(camp, stat).deposit_uniques_ratio
                  }}) | {{ stat.uniques }} ]
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.profit
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}₪</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>
      <div
        class="loader-div"
        v-if="
          campPerformanceBusy['7'] ||
            campPerformanceBusy['30'] ||
            campPerformanceBusy['90'] ||
            campPerformanceBusy['180']
        "
      >
        <loader :size="'8px'"></loader>
      </div>
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
    <div class="bottom-div" v-if="selectedCampTab === 'CR'">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="table">
        <table
          :key="time"
          v-for="time in getPerformanceCampaignTimeFrames(
            conversions[1].campConversion
          )"
        >
          <thead>
            <tr class="text-center">
              LAST
              {{
                time
              }}
              DAYS
            </tr>
          </thead>

          <!-- Campaigns-->
          <tbody>
            <table
              v-for="camp in conversions[1].campConversion[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{ camp.id }}
                  <br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
              </tr>
              <tr>
                <hr />
                profitable keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Users-->
          <tbody>
            <table
              v-for="camp in conversions[1].userConversion[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === camp.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
              </tr>
              <tr>
                <hr />
                profitable keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Keywords-->
          <tbody>
            <table
              v-for="camp in conversions[1].keyConversion[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{ camp.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
              </tr>
              <tr>
                <hr />
                profitable campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Countries-->
          <tbody>
            <table
              v-for="camp in conversions[1].countryConversion[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === camp.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
              </tr>
              <tr>
                <hr />
                profitable campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                profitable keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'negative' : 'positive'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>
      <div
        class="loader-div"
        v-if="
          campConversionBusy['7'] ||
            campConversionBusy['30'] ||
            campConversionBusy['90'] ||
            campConversionBusy['180']
        "
      >
        <loader :size="'8px'"></loader>
      </div>
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
    <div class="bottom-div" v-if="selectedCampTab === 'UNCR'">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="table">
        <table
          :key="time"
          v-for="time in getPerformanceCampaignTimeFrames(
            conversions[0].campConversion
          )"
        >
          <thead>
            <tr class="text-center">
              LAST
              {{
                time
              }}
              DAYS
            </tr>
          </thead>

          <!-- Campaigns-->
          <tbody>
            <table
              v-for="camp in conversions[0].campConversion[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{ camp.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
              </tr>
              <tr>
                <hr />
                loosing keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Users-->
          <tbody>
            <table
              v-for="camp in conversions[0].userConversion[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{
                    salesPersonList.find(item => item.id === camp.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
              </tr>
              <tr>
                <hr />
                loosing keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Keywords-->
          <tbody>
            <table
              v-for="camp in conversions[0].keyConversion[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{ camp.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
              </tr>
              <tr>
                <hr />
                loosing campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.country_id.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      dictionaries.general.countries.find(
                        country => country.id === cond.id
                      ).name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing countries:
              </tr>
              <tr v-for="stat in camp['country_id'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === stat.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>

          <!-- Countries-->
          <tbody>
            <table
              v-for="camp in conversions[0].countryConversion[time].slice(0, 3)"
              :key="camp.id"
            >
              <tr>
                <td>
                  {{
                    dictionaries.general.countries.find(
                      country => country.id === camp.id
                    ).name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in camp.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    camp.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ camp.total }} | {{ camp.deposits_amount }}</td>
              </tr>
              <tr>
                <hr />
                loosing campaigns:
              </tr>
              <tr
                v-for="stat in camp['campaign_aaid'].slice(0, 3)"
                :key="stat.id"
              >
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }} </span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing users:
              </tr>
              <tr v-for="stat in camp['users'].slice(0, 3)" :key="stat.id">
                <td>
                  {{
                    salesPersonList.find(item => item.id === stat.id).full_name
                  }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.keyword.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span> {{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
              <tr>
                <hr />
                loosing keywords:
              </tr>
              <tr v-for="stat in camp['keyword'].slice(0, 3)" :key="stat.id">
                <td>
                  {{ stat.id }}<br />
                  <span
                    class="report-rank"
                    v-for="rank in stat.rankings"
                    :key="rank"
                    v-if="rank['rank'] !== 0 && rank['rank'] !== 'new'"
                  >
                    <span :class="rank['rank'] < 0 ? 'positive' : 'negative'">
                      {{ rank["id"] }}:{{ rank["rank"] }}|
                    </span>
                  </span>
                </td>
                <td>
                  {{
                    stat.conversion
                      .toFixed(1)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }}%
                </td>
                <td>{{ stat.total }} | {{ stat.deposits_amount }}</td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.users.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>
                    {{
                      salesPersonList.find(item => item.id === cond.id)
                        .full_name
                    }}<label> </label>
                  </span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
                <td
                  class="secondary-conditional"
                  v-for="cond in stat.campaign_aaid.slice(0, 2)"
                  :key="cond.id"
                >
                  <span>{{ cond.id }} <label> </label></span>
                  <span class="money"
                    >{{
                      cond.conversion
                        .toFixed(1)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    }}%</span
                  >
                  <span>{{ cond.total }} | {{ cond.deposits_amount }}</span>
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>
      <div
        class="loader-div"
        v-if="
          campConversionBusy['7'] ||
            campConversionBusy['30'] ||
            campConversionBusy['90'] ||
            campConversionBusy['180']
        "
      >
        <loader :size="'8px'"></loader>
      </div>
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
    <div class="bottom-div" v-if="selectedCampTab === 'COUNTRIES'">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="table">
        <div id="container"></div>
        <table>
          <thead>
            <tr class="text-center">
              COUNTRIES - BROKERS STATISTICS
            </tr>
          </thead>
          <tbody>
            <table v-for="country in brokersReports" :key="country">
              <thead :id="getCountryAlpha(country.id)">
                {{
                  dictionaries.general.countries.find(
                    place => place.id == country.id
                  ).name
                }}
                |
                {{
                  country.total
                }}
              </thead>
              <tr v-for="broker in country['brokers']" :key="broker">
                {{
                  dictionaries.general.brokers.find(
                    item => item.id == broker.id
                  ).name
                }}
                |
                {{
                  broker.total
                }}
                <td
                  v-if="broker['methods']"
                  v-for="method in broker['methods']"
                  :key="method"
                >
                  {{
                    dictionaries.activity.deposit_methods.find(
                      item => item.id == method.id
                    ).method
                  }}
                  | {{ method.total }}
                </td>
              </tr>
            </table>
          </tbody>
        </table>
      </div>
      <div
        class="loader-div"
        v-if="
          campPerformanceBusy['7'] ||
            campPerformanceBusy['30'] ||
            campPerformanceBusy['90'] ||
            campPerformanceBusy['180']
        "
      >
        <loader :size="'8px'"></loader>
      </div>
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
    <div class="bottom-div" v-if="selectedCampTab === 'BROKERS'">
      <span v-if="false"
        >Forbidden, You are not authorized to see this data</span
      >
      <div class="table">
        <table>
          <thead>
            <tr class="text-center">
              BROKERS - COUNTRIES STATISTICS
            </tr>
          </thead>
          <tbody>
            <table v-for="broker in countriesReports" :key="broker">
              <thead>
                {{
                  dictionaries.general.brokers.find(
                    item => item.id == broker.id
                  ).name
                }}
                |
                {{
                  broker.total
                }}
              </thead>
              <tr v-for="country in broker['countries']" :key="country">
                {{
                  dictionaries.general.countries.find(
                    place => place.id == country.id
                  ).name
                }}
                |
                {{
                  country.total
                }}
              </tr>
            </table>
          </tbody>
        </table>
      </div>
      <div
        class="loader-div"
        v-if="
          campPerformanceBusy['7'] ||
            campPerformanceBusy['30'] ||
            campPerformanceBusy['90'] ||
            campPerformanceBusy['180']
        "
      >
        <loader :size="'8px'"></loader>
      </div>
      <div class="fab"><span class="fas fa-file-csv"></span></div>
    </div>
  </div>
</template>

<script>
import Loader from "../../../../../main/misc.main/loader/Loader";
import "anychart";
import {mapGetters, mapState} from "vuex";
import apiClientCreator from "../../../../../helpers/api/request";
export default {
  name: "Campaigns.container",
  components: { Loader },
  data() {
    return {
      map: anychart.map(),
      highLightedData: "",
      reqReportsBusy: false,
      campPerformanceBusy: {
        7: false,
        30: false,
        90: false,
        180: false
      },
      campConversionBusy: {
        7: false,
        30: false,
        90: false,
        180: false
      },
      brokersReports: [],
      countriesReports: [],
      profits: {
        0: {
          keyPerformance: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          userPerformance: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          countryPerformance: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          campPerformance: {
            7: [],
            30: [],
            90: [],
            180: []
          }
        },
        1: {
          keyPerformance: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          userPerformance: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          countryPerformance: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          campPerformance: {
            7: [],
            30: [],
            90: [],
            180: []
          }
        }
      },
      conversions: {
        0: {
          keyConversion: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          userConversion: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          countryConversion: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          campConversion: {
            7: [],
            30: [],
            90: [],
            180: []
          }
        },
        1: {
          keyConversion: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          userConversion: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          countryConversion: {
            7: [],
            30: [],
            90: [],
            180: []
          },
          campConversion: {
            7: [],
            30: [],
            90: [],
            180: []
          }
        }
      },
      campTabs: [
        {
          id: 0,
          name: "GOOD PROFITS",
          alias: "PROFIT"
        },
        {
          id: 1,
          name: "BAD PROFITS",
          alias: "UNPROFIT"
        },
        {
          id: 2,
          name: "GOOD CONVERSIONS",
          alias: "CR"
        },
        {
          id: 3,
          name: "BAD CONVERSIONS",
          alias: "UNCR"
        },
        {
          id: 4,
          name: "COUNTRIES",
          alias: "COUNTRIES"
        },
        {
          id: 5,
          name: "BROKERS",
          alias: "BROKERS"
        }
      ],
      selectedCampTab: "PROFIT"
    };
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  created() {},
  methods: {
    async execCampSync() {
      this.clearStatData();
      await this.getPerformanceCampaignsByTimeFrameProfit("profit", 1, 7);
      await this.getPerformanceCampaignsByTimeFrameConversion(
        "conversion",
        1,
        7
      );
      await this.getPerformanceCampaignsByTimeFrameProfit("profit", 0, 7);
      await this.getPerformanceCampaignsByTimeFrameConversion(
        "conversion",
        0,
        7
      );

      await this.getPerformanceCampaignsByTimeFrameProfit("profit", 1, 30);
      await this.getPerformanceCampaignsByTimeFrameConversion(
        "conversion",
        1,
        30
      );
      await this.getPerformanceCampaignsByTimeFrameProfit("profit", 0, 30);
      await this.getPerformanceCampaignsByTimeFrameConversion(
        "conversion",
        0,
        30
      );

      await this.getPerformanceCampaignsByTimeFrameProfit("profit", 1, 90);
      await this.getPerformanceCampaignsByTimeFrameConversion(
        "conversion",
        1,
        90
      );
      await this.getPerformanceCampaignsByTimeFrameProfit("profit", 0, 90);
      await this.getPerformanceCampaignsByTimeFrameConversion(
        "conversion",
        0,
        90
      );
      await this.getPerformanceCampaignsByTimeFrameProfit("profit", 1, 180);
      await this.getPerformanceCampaignsByTimeFrameConversion(
        "conversion",
        1,
        180
      );
      await this.getPerformanceCampaignsByTimeFrameProfit("profit", 0, 180);
      await this.getPerformanceCampaignsByTimeFrameConversion(
        "conversion",
        0,
        180
      );
    },
    checkPermissions(user, permitted) {
      return permitted.some(role => role === user.user.role);
    },
    getStatisticRatios(primary, secondary) {
      let ratios = {
        profit_ratio: 0,
        deposit_lead_ratio: 0,
        deposit_uniques_ratio: 0
      };
      if (secondary.profit !== 0) {
        ratios.profit_ratio =
          Math.abs((secondary.profit / primary.profit) * 100).toFixed(1) + "%";
      }
      if (secondary.total !== 0) {
        ratios.deposit_lead_ratio =
          Math.abs((secondary.deposits_amount / secondary.total) * 100).toFixed(
            1
          ) + "%";
      }
      if (secondary.uniques !== 0) {
        ratios.deposit_uniques_ratio = Math.abs(
          secondary.deposits_amount / secondary.uniques
        ).toFixed(1);
      }
      return ratios;
    },
    getPerformanceCampaignTimeFrames(times) {
      let times_array = [];
      for (let time in times) {
        times_array.push(time);
      }
      return times_array;
    },
    async getPerformanceCampaignsByTimeFrameProfit(orderBy, revenue, time) {
      if (
        !this.campPerformanceBusy[time] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.campPerformanceBusy[time] = true;
          const res = await apiClientCreator(
            `reports/campaigns/performance/${orderBy}/${revenue}/${time}`
          ).get("");
          this.profits[revenue].campPerformance[time] =
            res.data["campaign_aaid"];
          this.profits[revenue].userPerformance[time] = res.data["users"];
          this.profits[revenue].countryPerformance[time] =
            res.data["country_id"];
          this.profits[revenue].keyPerformance[time] = res.data["keyword"];
          this.campPerformanceBusy[time] = false;
        } catch (e) {
          this.campPerformanceBusy[time] = false;
        }
      }
    },
    async getPerformanceCampaignsByTimeFrameConversion(orderBy, revenue, time) {
      if (
        !this.campConversionBusy[time] &&
        this.checkPermissions(this.auth, [1, 2, 3, 4, 12])
      ) {
        try {
          this.campConversionBusy[time] = true;
          const res = await apiClientCreator(
            `reports/campaigns/performance/${orderBy}/${revenue}/${time}`
          ).get("");
          this.conversions[revenue].campConversion[time] =
            res.data["campaign_aaid"];
          this.conversions[revenue].userConversion[time] = res.data["users"];
          this.conversions[revenue].countryConversion[time] =
            res.data["country_id"];
          this.conversions[revenue].keyConversion[time] = res.data["keyword"];

          this.campConversionBusy[time] = false;
        } catch (e) {
          this.campConversionBusy[time] = false;
        }
      }
    },
    async getPerformanceByDate() {
      this.clearStatData();
      const res = await apiClientCreator(
        `reports/campaigns/performance/previousStats`
      ).get("");
      try {
        let profits = res.data["profit"];
        let conversions = res.data["conversion"];
        let revenue = [0, 1];
        let time_frames = [7, 30, 90, 180];
        revenue.forEach(revenue => {
          time_frames.forEach(time => {
            this.profits[revenue].keyPerformance[time] =
              profits[revenue][time]["keyword"];
            this.profits[revenue].countryPerformance[time] =
              profits[revenue][time]["country_id"];
            this.profits[revenue].userPerformance[time] =
              profits[revenue][time]["users"];
            this.profits[revenue].campPerformance[time] =
              profits[revenue][time]["campaign_aaid"];

            this.conversions[revenue].keyConversion[time] =
              conversions[revenue][time]["keyword"];
            this.conversions[revenue].countryConversion[time] =
              conversions[revenue][time]["country_id"];
            this.conversions[revenue].userConversion[time] =
              conversions[revenue][time]["users"];
            this.conversions[revenue].campConversion[time] =
              conversions[revenue][time]["campaign_aaid"];
          });
        });
      } catch (e) {}
    },
    async executeBrokersReports() {
      this.brokersReports = [];
      const res = await apiClientCreator(
        `reports/brokers/performance/statistics/reports/true`
      ).get("");
      this.brokersReports = res.data;
      let countries_data = [];
      this.brokersReports.forEach(country => {
        let country_data = {};
        country_data["id"] = this.dictionaries.general.countries.find(
          place => place.id == country.id
        ).alpha2;
        country_data["value"] = country.total;
        countries_data.push(country_data);
      });
      this.fillHeatMap(countries_data);
    },
    async executeCountriesReports() {
      this.countriesReports = [];
      const res = await apiClientCreator(
        `reports/countries/performance/reports/true`
      ).get("");
      this.countriesReports = res.data;
    },
    clearStatData() {
      let revenue = [0, 1];
      let time_frames = [7, 30, 90, 180];
      revenue.forEach(revenue => {
        time_frames.forEach(time => {
          this.profits[revenue].keyPerformance[time] = [];
          this.profits[revenue].countryPerformance[time] = [];
          this.profits[revenue].userPerformance[time] = [];
          this.profits[revenue].campPerformance[time] = [];

          this.conversions[revenue].keyConversion[time] = [];
          this.conversions[revenue].countryConversion[time] = [];
          this.conversions[revenue].userConversion[time] = [];
          this.conversions[revenue].campConversion[time] = [];
        });
      });
    },
    fillHeatMap(data) {
      // create map
      // let map = anychart.map();
      this.map.container("container");
      // create data set
      let dataSet = anychart.data.set(data);

      // create choropleth series
      let series = this.map.choropleth(dataSet);

      // set geoIdField to 'id', this field contains in geo data meta properties
      series.geoIdField("id");

      // set map color settings
      series.colorScale(anychart.scales.linearColor("#deebf7", "#3182bd"));
      series.hovered().fill("#addd8e");

      this.map.listen("dblClick", function(e) {
        // Clicking on map where there are no valid countries
        if (e.pointIndex === undefined && this.highLightedData !== undefined) {
          document
            .getElementById(this.highLightedData)
            .classList.remove("highLight");
          // Clicking on map where there are valid countries
        } else if (this.highLightedData !== data[e.pointIndex].id) {
          if (this.highLightedData !== undefined) {
            document
              .getElementById(this.highLightedData)
              .classList.remove("highLight");
          }
          this.highLightedData = data[e.pointIndex].id;
          document
            .getElementById(this.highLightedData)
            .classList.add("highLight");
        }
      });
      this.map.geoData(anychart.maps.world);

      //initiate map drawing
      this.map.draw();
    },
    getCountryAlpha(id) {
      return this.dictionaries.general.countries.find(place => place.id == id)
        .alpha2;
    }
  }
};
</script>

<style scoped>
.body-div {
  padding: 1px 5px 1px 5px;
}
.main-nav {
  display: flex;
  flex-direction: column;
  border-radius: 0;
  background: white;
  margin-top: 0.3rem !important;
  border-bottom: solid 2px #eff3f6;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
/*
	.style-nav.style2 li{
	    border-radius: 5px 5px 0px 0px;
	    transition:transform 0.1s ease;
	}
	.style-nav.style2 li:not(:last-child){
	    margin-right:2px;
	}
	*/

.style-nav .router-link {
  max-width: 150px;
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.top-div {
  width: 100%;
  height: 340px;
  margin: auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
}
.bottom-div {
  width: 100%;
  height: 650px;
  margin: 5px auto;
  background: white;
  border-radius: 3px;
  padding: 5px;
  position: relative;
  overflow-y: scroll;
}
.fab {
  background-color: transparent;
  padding: 0;
  font-size: 30px;
  line-height: 30px;
  color: green;
  text-align: center;
  position: absolute;
  right: 10px;
  bottom: 10px;
  border-radius: 20%;
  transition: all 0.1s ease-in-out;
  cursor: pointer;
}

.fab:hover {
  box-shadow: 0 5px 11px 0 #666;
  transform: scale(1.05);
}
.table {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20px;
}
.table table {
  font-size: 13px;
  width: 1700px;
  margin: 3em 0;
}
.table thead {
  border-bottom: solid 2px #eff3f6;
}
.table tfoot {
  border-top: solid 2px #eff3f6;
  color: red;
}
.table th {
  text-align: center;
}
.text-center {
  font-weight: bold;
}

.disabled {
  display: none;
}
.conditional {
  color: black !important;
}
.money {
  padding: 0 15px;
}
.stat-buttons {
  display: flex;
  justify-content: center;
  padding: 0.5em 0;
}
.stat-button {
  margin: 1em;
}

hr {
  margin-bottom: 5px;
  margin-top: 5px;
}
html,
body,
#container {
  width: 100%;
  height: 700px;
  margin: 0;
  padding: 0;
}
.highLight {
  background: yellow;
}
.report-rank {
  font-size: 12px;
}
.negative {
  color: red;
}
.positive {
  color: green;
}
</style>
